import * as React from "react";
import Loader from "src/js/components/Loader/LoadingSpinner";

// a single location item in the search results.
const LocationItem: React.FunctionComponent<{
  item: SimpleLocation;
  onClick: (item: SimpleLocation) => void;
}> = (props) => {
  const location = props.item;
  const [submitting, setSubmitting] = React.useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    if (submitting) {
      return;
    }
    setSubmitting(true);
    props.onClick(location);
  };

  const title = "Shop for products at " + location.Name;

  return (
    <div className="location-option">
      <button
        type="button"
        className={`hgs-button ${submitting ? "submitting" : ""}`}
        onClick={handleClick}
        title={title}
      >
        {!submitting ? (
          "Select Location"
        ) : (
          <Loader message="Saving Location. . ." fontSize="14px"></Loader>
        )}
      </button>
      <div className="hospital-result">
        <p className="loc-name">{location.Name}</p>
        <p className="loc-address">
          {location.StreetAddress}
          <br />
          <span className="loc-city">{location.City}, </span>
          <span className="loc-state">{location.State} </span>
          <span>{location.Zip}</span>
        </p>
      </div>
    </div>
  );
};

// the list of locations used in the search form.
export const LocationResults: React.FunctionComponent<{
  results: Array<SimpleLocation>;
  handleSelect: (item: SimpleLocation) => void;
}> = (props) => {
  const resultsRef = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    if (
      resultsRef !== null &&
      resultsRef.current !== null &&
      props.results.length > 0
    ) {
      resultsRef.current.scrollIntoView({
        block: "center",
        behavior: "smooth",
      });
    }
  }, [props.results]);

  const results = props.results;

  return (
    <div className="location-results" ref={resultsRef}>
      {results.map((item: SimpleLocation) => (
        <LocationItem onClick={props.handleSelect} item={item} key={item.ID} />
      ))}
    </div>
  );
};
